// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_rb-0";